// src/Components/AnnouncementBanner.js
import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";

function AnnouncementBanner() {
  const [announcement, setAnnouncement] = useState(null);

  useEffect(() => {
    const handleNewAnnouncement = (e) => {
      const ann = e.detail; // { id: '...', text: '...' }

      const dismissedKey = `announcement_dismissed_${ann.id}`;
      const isDismissed = localStorage.getItem(dismissedKey);

      if (isDismissed) {
        return;
      }
      setAnnouncement(ann);
    };

    window.addEventListener("new_announcement", handleNewAnnouncement);

    return () => {
      window.removeEventListener("new_announcement", handleNewAnnouncement);
    };
  }, []);

  const handleClose = () => {
    if (announcement) {
      const dismissedKey = `announcement_dismissed_${announcement.id}`;
      localStorage.setItem(dismissedKey, "true");
    }
    setAnnouncement(null);
  };

  if (!announcement) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: "#e6f7ff",
        padding: "16px 24px",
        borderBottom: "1px solid #91d5ff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div style={{ flex: 1 }}>
        <p style={{ margin: 0, fontWeight: 500, color: "#1890ff" }}>
          Aviso importante 📢
        </p>
        <p style={{ margin: "8px 0 0 0" }}>{announcement.text}</p>
      </div>

      <Button
        type="text"
        icon={<CloseOutlined />}
        onClick={handleClose}
        style={{
          color: "#000",
          marginLeft: 16,
          alignSelf: "flex-start",
        }}
      />
    </div>
  );
}

export default AnnouncementBanner;
